module.exports = __webpack_public_path__ + "static/media/wavm8s-025-ship-sket.008a8ef.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-025-ship-sket.mp3
// module id = BTZT
// module chunks = 0